import ZSwitchimg from './switch-img.vue'
export default ZSwitchimg